const languages = [{
    value: "en", text: "English"
},{
    value: "de", text: "Deutsch"
},{
    value: "es", text: "Espanol"
},{
    value: "fr", text: "Francais"
},{
    value: "nl", text: "Nederlands"
}]

export default languages;
